import React, {useEffect} from "react";
import {defaultTheme, Provider} from "@adobe/react-spectrum";
import Home from "./pages/Home";

function App() {

    function appHeight() {
        const doc = document.documentElement
        doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
    }

    useEffect(() => {
        window.addEventListener('resize', appHeight);
        appHeight();

        return () => {
            window.removeEventListener('resize', appHeight);
        };
    }, []);

    return (
        <Provider theme={defaultTheme} colorScheme="light">
            <div className="App">
                <Home />
            </div>
        </Provider>
    );
}

export default App;
